/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Fbx(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4687 5.50526C10.4702 8.59274 10.4843 11.6818 10.4624 14.7708C11.2503 14.8582 12.0584 14.8847 12.8432 14.7427C12.7995 13.5258 12.8416 12.3074 12.8182 11.0904C13.8229 10.9828 14.8354 11.0639 15.8433 11.0343C15.8308 10.493 15.8324 9.95317 15.8448 9.41177C14.8402 9.40555 13.8338 9.42114 12.8276 9.4024C12.8182 8.6723 12.8198 7.9406 12.826 7.21043C14.0226 7.21204 15.2208 7.20735 16.4174 7.21512C16.4205 6.6426 16.4158 6.06848 16.4143 5.49436C14.4329 5.50834 12.45 5.49275 10.4687 5.50526ZM4.42011 1.70327H20.3177C20.9277 1.73446 21.5486 2.17442 21.5829 2.82027C21.6204 3.72201 21.5814 4.62695 21.5954 5.53022C21.6048 9.86418 21.597 14.1982 21.6001 18.5307C16.6249 18.5354 11.6497 18.5275 6.6745 18.5369C5.92721 18.5572 5.17831 18.5946 4.43101 18.5307C4.392 12.9298 4.41382 7.32901 4.41856 1.72817L4.42011 1.70327Z"
        fill="#88A943"
      />
      <path
        d="M0.75 3.94679C1.95907 3.18544 3.19156 2.46003 4.41943 1.72826C4.41468 7.3291 4.39287 12.9299 4.43188 18.5308C3.86712 18.8646 3.30859 19.2094 2.7423 19.5433C2.0761 19.9411 1.41773 20.3499 0.75 20.7461V3.94679Z"
        fill="#A7C36A"
      />
      <path
        d="M10.4691 5.50626C12.4504 5.49375 14.4334 5.50934 16.4148 5.49535C16.4163 6.06948 16.421 6.6436 16.4178 7.21612C15.2212 7.20835 14.0231 7.21304 12.8264 7.21144C12.8202 7.9416 12.8187 8.6733 12.828 9.40341C13.8343 9.42214 14.8406 9.40655 15.8453 9.41277C15.8328 9.95417 15.8313 10.494 15.8437 11.0353C14.8359 11.0649 13.8234 10.9838 12.8187 11.0914C12.8421 12.3084 12.7999 13.5268 12.8436 14.7437C12.0589 14.8857 11.2507 14.8592 10.4629 14.7718C10.4847 11.6828 10.4707 8.59374 10.4691 5.50626Z"
        fill="#FFFEFE"
      />
      <path
        d="M21.5964 5.53029C22.1472 5.52561 22.6994 5.52561 23.2501 5.52407C23.2377 11.1155 23.2486 16.7054 23.2439 22.2969H3.87036C3.36643 22.2189 2.87347 21.8834 2.77203 21.3593C2.67534 20.7587 2.74553 20.1471 2.74239 19.5433C3.30875 19.2094 3.86728 18.8646 4.43203 18.5308C5.17933 18.5947 5.92816 18.5573 6.67546 18.537C11.6507 18.5276 16.6259 18.5354 21.6011 18.5308C21.598 14.1983 21.6058 9.86431 21.5964 5.53029Z"
        fill="#4F6227"
      />
    </svg>
  )
}

Fbx.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Fbx
